/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import {dlsColor, dlsTypography} from '@ion/dls/src/theme/theme';

export interface CTALinkProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: unknown;
}

const useStyles = makeStyles(theme => {
  const {textTransform, fontWeight, fontSize, lineHeight} = dlsTypography('cta');
  return {
    root : {
      fontWeight,
      textTransform,
      fontSize,
      lineHeight,
      color  : dlsColor('grey2'),
      cursor : 'pointer'
    }
  };
});

/**
 * Call To Action Link button
 *
 * ```typescript
 *
 * import React from 'react';
 * import { IconButton } from '@ion/dls/src/components/buttons/';
 *
 * function MyComponent {
 *   return (
 *     <React.Fragment>
 *       <CTALink>CTALink</CTALink>
 *     </React.Fragment>
 *   );
 * }
 * ```
 */
export const CTALink = ({children, ...props}: CTALinkProps) => {
  const classes = useStyles();
  return (
    <span className={classnames(classes.root, props.className)}
      {...props}>
      {children}
    </span>
  );
};

export default CTALink;
